import { AnalyticsPage } from "@/features/analytics";
import { requireAdmin } from "@/lib/tanstack-router/requireAdmin";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/analytics"
)({
  component: requireAdmin(Analytics)
});

function Analytics() {
  return <AnalyticsPage />;
}
